import * as yup from 'yup'

export class PersonHREmploymentInformationDto {
  birthday?: string = undefined
  employmentStartDate?: string = undefined
  employmentEndDate?: string = undefined
}

export const personHREmploymentInformationValidationSchema = yup.object({
  birthday: yup.date().typeError('Birthday must be a date.').nullable(),
  employmentStartDate: yup.date().typeError('Start Date must be a date.').nullable(),
  employmentEndDate: yup.date().typeError('End Date must be a date.').nullable()
})
